<template>
  <div>
    <router-view />
    <van-tabbar route fixed active-color="#45b97c">
      <van-tabbar-item
        v-for="(item, index) of tabs"
        :key="index"
        :icon="item.icon"
        :url="item.url"
        :to="item.path"
        replace
      >
        {{ item.title }}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        { path: '/venue_member_extract_brokerage', icon: 'home-o', title: '提现' },
        { path: '/venue_member_extract_order', icon: 'notes-o', title: '记录' },
      ],
    };
  },
};
</script>
